// @ts-nocheck
/* eslint-disable */
import MyMapsPopup from "~/es6/mymaps.popup";
import { _ } from "~/i18n";
import { node } from "~/util/dom";

export default class Exif {
	constructor(cb) {
		this._data = null;

		this._cb = cb;

		this._popup = new MyMapsPopup({
			name: "photo-exif-data",
			cb: event => {
				if (event.name === "close") {
					let galleryData = Mapy.getComponent("gallery").isActive() ? Mapy.getComponent("gallery").logData : {};
					let logData = {
						text: "exifClose",
						place: "detail",
						galleryType: galleryData?.galleryType || "photomap",
						section: "gallery",
					};

					Mapy.getComponent("logger").log("click", Object.assign(galleryData, logData));
				}

				this._cb(event);
			},
		});

		this._node = this._popup.getContainer();
	}

	destroy() {
		this._node = null;
		this._popup.destroy();
	}

	open(data) {
		this._build(data);
		this._popup.open();
		this._popup.closeButton.setAttribute("data-log-ignore", "1");
	}

	close() {
		this._data = null;
		this._popup.close();
	}

	_build(data) {
		this._node.appendChild(node("h3", {}, _("photo.exif.title")));

		let table = node("table");

		data.exif.forEach(d => {
			let row = node("tr");
			let name = node("td", {}, d.name);
			let value = node("td", {}, d.value);

			row.appendChild(name);
			row.appendChild(value);

			table.appendChild(row);
		});

		this._node.appendChild(table);
	}
}
